/* eslint-disable consistent-return */
import OneTrustBase from '@narf/onetrust'
import { useUnauth } from '@narf/unauth'

import Head from 'next/head'
import { useRouter } from 'next/router'

import Faciliti from 'components/faciliti'
import Hotjar from 'components/hotjar'
import Mixpanel from 'components/track'
import { useAuth2 } from 'context/auth2'

const env = process.env.CUSTOM_ENV

const OneTrust = () => {
  const router = useRouter()

  const isWebview = router.query.iswebview === 'true'

  const { siteId: siteIdAuth2 } = useAuth2() // TODO(jose.mortola): delete this once unified with unauth
  const { siteId: siteIdUnauth } = useUnauth()
  const siteId = siteIdAuth2 || siteIdUnauth

  if (!siteId || isWebview) return null // NOTE: preventing any side-effect by not rendering

  return (
    <Head>
      <OneTrustBase siteId={siteId} env={env} />
    </Head>
  )
}

export const ThirdPartyScripts = () => (
  <>
    <OneTrust />
    <Mixpanel />
    <Hotjar />
    <Faciliti />
  </>
)
